import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { CancelOrderModal } from 'features/Inventories/components/CancelOrderModal'
import { RejectOrderModal } from 'features/Inventories/components/RejectOrderModal'
import { isCartAvailable } from 'resolvers/carts'
import { canWriteCart, canCancelCart } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'
import IconButton from 'components/v2/IconButton'

export const PendingOrdersActions = ({ cart = {}, order }: TSFixMe): TSFixMe => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenCancelOrderModal, setOpenCancelOrderModal] = useState(false)
  const [isOpenRejectOrderModal, setOpenRejectOrderModal] = useState(false)

  const login = useLogin()

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  const cartIsOrderDestination = cart.id === order.destination.id
  const canWrite = canWriteCart(login.accessToken.policies)
  const canReceiveOrder = canWrite && cartIsOrderDestination && isCartAvailable(cart)
  const cartIsOrderOrigin = cart.id === order.origin.id
  const canCancel = canCancelCart(login.accessToken.policies)

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): TSFixMe => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item action noPadding={canReceiveOrder} disabled={!canReceiveOrder}>
              {canReceiveOrder ? (
                <List.Link to={`/carts/${cart.id}/orders/${order.id}/receive`}>
                  <FormattedMessage id="spanish.orders.pending.actions.accept.label" defaultMessage="Recibir" />
                </List.Link>
              ) : (
                <FormattedMessage id="spanish.orders.pending.actions.accept.label" defaultMessage="Recibir" />
              )}
            </List.Item>

            <List.Item
              action
              onClick={(): TSFixMe => {
                if (canCancel && cartIsOrderOrigin) {
                  setOpenDropdown(false)
                  setOpenCancelOrderModal(true)
                }
              }}
              disabled={!(canCancel && cartIsOrderOrigin)}
            >
              <FormattedMessage id="spanish.dictionary.cancel" defaultMessage="Cancelar" />
            </List.Item>
            <List.Item
              action
              onClick={(): TSFixMe => {
                if (canWrite && cartIsOrderDestination) {
                  setOpenDropdown(false)
                  setOpenRejectOrderModal(true)
                }
              }}
              disabled={!(canWrite && cartIsOrderDestination)}
            >
              <FormattedMessage id="spanish.dictionary.reject" defaultMessage="Rechazar" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
      {isOpenCancelOrderModal && (
        <CancelOrderModal
          order={order}
          inventoryId={cart.id}
          closeModal={(): TSFixMe => setOpenCancelOrderModal(false)}
        />
      )}
      {isOpenRejectOrderModal && (
        <RejectOrderModal
          order={order}
          inventoryId={cart.id}
          closeModal={(): TSFixMe => setOpenRejectOrderModal(false)}
        />
      )}
    </>
  )
}
